import { useState } from 'react';
import { UserPlan, UserPlanBalance, UserPlanRenewsDate } from '../../components/common/user-plan/user-plan';
import { FormBlock } from '../../components/modals/settings-modal/form-block';
import { PageHeader } from '../../components/modals/settings-modal/page-header';
import { CancelUserPlanModal } from '../../components/modals/cancel-user-plan-modal';
import { InlineSpinner } from '../../components/common/spinner';
import useAuth from '../../hooks/utils/useAuth';

export const MyPlan = () => {
  const { user, isLoading: userIsLoading } = useAuth();
  const [showCancelUserPlanModal, setShowCancelUserPlanModal] = useState<boolean>(false);

  const userPackage = user?.caller_role.active_subscription?.package;
  const logoImage = userPackage?.my_plan_file_url || userPackage?.client.logo_file_url || '';
  const planName = userPackage?.name || '';
  const groupName = userPackage?.client.name || '';

  if (userIsLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <InlineSpinner />
      </div>
    );
  }

  return (
    <div className="p-6">
      <PageHeader header="My plan" subHeader={`You're currently on the ${planName} plan provided by ${groupName}.`} />
      {logoImage && (
        <div className="mt-6 rounded-lg border border-neutral-200 bg-white py-6">
          <img className="mx-auto max-h-24" src={logoImage} alt="Group Logo" />
        </div>
      )}
      {!!user && (
        <div className="mt-6 space-y-4">
          <FormBlock>
            <UserPlan user={user} />
          </FormBlock>
          {user?.user_subscription?.remaining_minutes && user?.onCappedPlan && (
            <FormBlock>
              <UserPlanBalance user={user} />
            </FormBlock>
          )}
          {(user?.onCappedPlan || user?.onMemberPayPlan) && (
            <FormBlock>
              <UserPlanRenewsDate />
            </FormBlock>
          )}
          {user?.onMemberPayPlan && (
            <button
              className="text-primary font-open-sans mt-4 text-base font-bold"
              onClick={() => setShowCancelUserPlanModal(true)}
            >
              Cancel plan
            </button>
          )}
        </div>
      )}
      <CancelUserPlanModal open={showCancelUserPlanModal} onClose={() => setShowCancelUserPlanModal(false)} />
    </div>
  );
};
